import { configureOcr, tesseractVersion } from '@zeed/ocr'

// Pin every Tesseract.js asset to our own origin. Defaults would otherwise
// pull worker.min.js + tesseract-core-* from cdn.jsdelivr.net and the
// .traineddata.gz files from tessdata.projectnaptha.com (Sentry VIIDOO-7R).
//
// Worker + core are namespaced by tesseract.js version (matches the layout
// produced by scripts/cp-tesseract.js), so the URL changes on every upgrade
// and the .htaccess can serve them as `immutable` without risking a stale
// worker against a fresh main bundle.
//
// `gzip: false` because we ship uncompressed `.traineddata` from tessdata_best.
//
// `corePath` points at a specific `.wasm.js` file (not the directory) to
// force the SIMD-LSTM variant. The directory form lets tesseract.js
// auto-select via wasm-feature-detect, which picks `relaxedsimd-lstm` in
// Firefox — that build references `DotProductSSE`, an x86 SSE intrinsic
// Firefox does not implement, and OCR aborts at runtime.
const base = `/static/tesseract/v${tesseractVersion}`
configureOcr({
  workerPath: `${base}/worker.min.js`,
  corePath: `${base}/core/tesseract-core-simd-lstm.wasm.js`,
  langPath: '/static/tesseract/lang',
  gzip: false,
})
